import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import axios from "axios";
import { Link } from "react-router-dom";

// import amb_background from "../../../assets/images/default_ambassador_background.jpg";
// import amb_background from "../../../assets/images/amba_cover_2.jpeg";
// import amb_background from "../../../assets/images/amb_cover_3.jpeg";
// import amb_background from "../../../assets/images/amb_cover_4.jpeg";
// import amb_background from "../../../assets/images/amb_obl.jpg";
import amb_background from "../../../assets/images/obl_2.jpg";
import { resolveFileUrl } from "constants/config";
import amb_ava from "../../../assets/images/ava_img.jpg";

import loc_city_img from "../../../assets/images/location_city.png";
import university_img from "../../../assets/images/university_2.png";
import { getName } from "./AmbassadorsList";
import UserPostsPanel from "../../posts/panels/UserPostsPanel";
import PostsAPI from "../../../api/PostsAPI";
import { useStorageListener } from "../../../hooks/useStorage";

const POSTS = [
    {
        id: 1,
        title: "Студенческие тропы России",
        postImage: "https://sun9-43.userapi.com/impg/IzLexlHcXpg6LPoAKryn29Sm1b1g1fyQCKMkWg/DgtjTMeySHI.jpg?size=1280x841&quality=96&sign=0e4983cb7ef692abbaffd9b475216f79&c_uniq_tag=5msr2VHfzsevtWqIlEdwpApPULlYXZJTravlLHIhEfo&type=album",
        description: `Студтуризм раскрыл мне Россию: солнечный Сочи, мистический Байкал и величественный Саратов. Каждый уголок удивляет!`
    },
    {
        id: 1,
        title: "Городские легенды",
        postImage: "https://avatars.dzeninfra.ru/get-zen_doc/5192222/pub_63343d44d9375940c725512f_63343ddfb5ad6f0853644534/scale_1200",
        description: `Открывая для себя города России: загадочный Казань, величественный Питер и старинный Ярославль. История на каждом шагу!`
    },
    {
        id: 1,
        title: "Природные чудеса",
        postImage: "https://druzhniy-center.ru/wp-content/uploads/f/9/2/f92cb28b3b576fc74ccbe505c89994b3.jpeg",
        description: `Природа России впечатляет: лесные просторы Тайги, горные вершины Кавказа и бескрайние степи Алтая. Природа дышит волшебством!`
    },
    {
        id: 1,
        title: "Культурное наследие",
        postImage: "https://mykaleidoscope.ru/x/uploads/posts/2022-09/1663186958_6-mykaleidoscope-ru-p-vantovii-most-vladivostok-oboi-6.jpg",
        description: `В сердце культуры: уникальные музеи Москвы, театры Новосибирска и фестивали Владивостока. Искусство объединяет!`
    },
    {
        id: 1,
        title: "Северное сияние",
        postImage: "https://static.tildacdn.com/tild6162-3463-4538-b832-313237653766/murmansk.jpg",
        description: `Магия севера: ночные полярные дни в Мурманске, северное сияние и мир тундры. Завораживающая атмосфера!`
    },
    {
        id: 1,
        title: "Реки и озёра",
        postImage: "https://superwalls.top/uploads/posts/2022-06/1655442192_45-gamerwall-pro-p-reka-volga-v-balakovo-priroda-krasivo-foto-46.jpg",
        description: `Водные просторы России: плавание по Волге, рыбалка на Онеге и закаты на Байкале. Вода приводит к размышлениям!`
    }


];

function linkifyText(text) {
    // Regular expression to match email addresses
    const emailRegex = /(\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b)/g;

    // Regular expression to match Telegram nicknames
    const telegramRegex = /(\B@[a-zA-Z0-9._]+)/g;

    // First replace Telegram nicknames with Telegram links
    text = text.replace(telegramRegex, (username) => {
        // Remove '@' for the link
        const usernameWithoutAt = username.replace("@", "");
        return `<a href="https://t.me/${usernameWithoutAt}">${username}</a>`;
    });

    // Then replace email addresses with mailto links
    text = text.replace(emailRegex, (email) => {
        return `<a href="mailto:${email}">${email}</a>`;
    });

    return text;
}

export default function AmbassadorViewTool(props) {
    const {
        coverImage,
        avatar,
        name,
        description,
        city,
        universityName,
        ambassadorUniversityId,

        postId = undefined,
        ambassadorNickname,
        ambassadorContactsInfo,
        ambassadorAboutMe,
        isVip,
        id,
        ambassadorSocialLinksInfo,
        ambassadorHideContacts = true
    } = props;

    let desc = ambassadorAboutMe || description;

    const [ambPost, setAmbPost] = useState(undefined);

    let refUrl = `https://студтуризм.рф/invite/${id}`;

    const uData = useStorageListener("user", {});
    // let shouldShowTelegramModal = ((hasNoTelegram == true) && (uData.isVip == true || uData.userRole == 'uni-admin'));
    let isOneOfAdmins = (uData != undefined && ["admin", "uni-admin"].indexOf(uData.userRole) >= 0);

    useEffect(() => {
        if (postId == undefined) {
            return;
        }
        setAmbPost(undefined);
        PostsAPI.getPost(postId).then(pp => {
            setAmbPost(pp);
        });
    }, [postId]);

    return (
        <Wrapper>

            <TopPlaceholder src={resolveFileUrl(coverImage || amb_background)}>

                <CoverSection>

                    <WhiteCoverSection>
                        <WhiteCoverSectionInner>
                            <AvatarPlaceholder src={resolveFileUrl(avatar || amb_ava)}>

                            </AvatarPlaceholder>

                            <UserInfoPlaceholder>
                                <UserName
                                    style={{}}>
                                    <span>
                                        {getName(props)}
                                        <span style={{ float: "right" }}>
                                                <BadgeSpan style={{ marginLeft: 4 }}>
                                                    {props?.ambassadorType || 'Амбассадор'}
                                                </BadgeSpan>
                                            </span>
                                    </span>

                                    {(refUrl == undefined || refUrl == "") ? null :
                                        <UserDescription>
                                            <a href={refUrl} target={"_blank"} style={{
                                                textDecoration: "underline",
                                                fontSize: "12px",
                                                fontWeight: "normal",
                                                opacity: 0.6
                                            }}>
                                                {refUrl}
                                            </a>
                                        </UserDescription>
                                    }

                                </UserName>
                                {(desc == undefined || desc == "") ? null :
                                    <UserDescription>
                                        {desc}
                                    </UserDescription>
                                }


                                {(ambassadorSocialLinksInfo == undefined || ambassadorSocialLinksInfo == "") ? null :
                                    <UserDescription>
                                        {ambassadorSocialLinksInfo}
                                    </UserDescription>
                                }


                                <ContactsPlaceholder>
                                    {city == undefined || city == "" ? null :
                                        <ContactItem>
                                            <img src={loc_city_img} style={{ height: 20, marginRight: 5 }} />
                                            <ContSpan style={{ opacity: 0.7 }}>
                                                {city}
                                            </ContSpan>
                                        </ContactItem>
                                    }
                                    <ContactItem>
                                        <img src={university_img}
                                             style={{ height: 20, marginRight: 5, opacity: 0.4 }} />
                                        {ambassadorUniversityId ? (
                                            <Link to={`/university/${ambassadorUniversityId}`} style={{ textDecoration: 'none' }}>
                                                <ContSpan style={{ opacity: 0.7, cursor: 'pointer', color: '#02bf89' }}>
                                                    {universityName}
                                                </ContSpan>
                                            </Link>
                                        ) : (
                                            <ContSpan style={{ opacity: 0.7 }}>
                                                {universityName}
                                            </ContSpan>
                                        )}
                                    </ContactItem>

                                    {ambassadorNickname == undefined ? null :
                                        <ContactItem>
                                            {/*<img src={university_img}*/}
                                            {/*     style={{ height: 20, marginRight: 5, opacity: 0.4 }} />*/}
                                            <ContSpan style={{ opacity: 0.7 }}>
                                                {`@${ambassadorNickname}`}
                                            </ContSpan>
                                        </ContactItem>
                                    }

                                    {(ambassadorContactsInfo == undefined || ambassadorContactsInfo == "") || (ambassadorHideContacts == true && isOneOfAdmins == false) ? null :
                                        <ContactItem>
                                            {/*<img src={university_img}*/}
                                            {/*     style={{ height: 20, marginRight: 5, opacity: 0.4 }} />*/}
                                            <ContSpan style={{ opacity: 0.7 }}>
                                                {/*{`${ambassadorContactsInfo}`}*/}
                                                <span
                                                    dangerouslySetInnerHTML={{ __html: linkifyText(ambassadorContactsInfo) }}></span>
                                            </ContSpan>
                                        </ContactItem>
                                    }

                                </ContactsPlaceholder>

                                {/*{ambassadorAboutMe == undefined ? null :*/}
                                {/*    <div>*/}
                                {/*        {ambassadorAboutMe}*/}
                                {/*    </div>*/}
                                {/*}*/}

                            </UserInfoPlaceholder>

                        </WhiteCoverSectionInner>
                    </WhiteCoverSection>

                </CoverSection>

            </TopPlaceholder>

            <div style={{ marginTop: 20, marginBottom: 20 }}>

                {ambPost != undefined ? null :
                    <UserPostsPanel
                        showtPostsOnModeration={false}
                        userId={props.id}
                        onPostClick={p => {
                            window.open(`/ambassadors/${props.id}/posts/${p.id}`, "_blank");
                        }}
                    />
                }

                {ambPost == undefined ? null :
                    <div>
                        {/*{JSON.stringify(ambPost)}*/}
                        <h2>
                            {ambPost?.name}
                        </h2>
                        <h4>
                            {ambPost?.description}
                        </h4>

                        <div style={{ marginTop: 15, marginBottom: 15 }}>
                            <div dangerouslySetInnerHTML={{ __html: ambPost?.html }}>

                            </div>
                        </div>

                    </div>
                }

            </div>

        </Wrapper>
    );
}

const borderRadius = 12;

const BadgeSpan = styled.span`
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  height: 24px;
  line-height: 24px;
  color: rgb(21, 128, 61);
  background-color: rgb(220, 252, 231);
  border-radius: 1000px;
  font-size: 12px;
  alignment: right;
  //opacity: 0.6;
`;

const Wrapper = styled.div`
  //width: 1020px;
  //margin: 0 auto;
`;

const PostInfoPlaceholder = styled.div`

`;

const PostItemContent = styled.div`
  padding: 20px;
`;

const PostTopContent = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  opacity: 0.9;
`;

const PostName = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-size: 24px;
  font-weight: bold;

`;

const PostItemWrapper = styled.div`
  box-sizing: border-box;
  width: 33.333%;
  padding: 10px;
`;

const PostItem = styled.div`
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: ${borderRadius}px;
`;

const PostItemAvatarPlaceholder = styled.div`
  width: 100%;
  height: 224px;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.src});
  border-top-left-radius: ${borderRadius}px;
  border-top-right-radius: ${borderRadius}px;
`;

const PostsPlaceholder = styled.div`
  //width: 680px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

`;


const UserInfoPlaceholder = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding-left: 250px;
  @media (max-width: 800px) {
    padding-left: 0px;
  }
`;

const UserName = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-size: 24px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 800px) {
    display: block;
    text-align: center;
  }
`;

const UserDescription = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-size: 16px;
  opacity: 0.6;
  //width: 560px;
  @media (max-width: 1000px) {
    width: auto;
    text-align: center;
  }
`;

const ContactsPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  alignment: center;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  margin-top: 14px;
  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const ContSpan = styled.span`
  font-family: "Noto Sans", sans-serif;

  &:hover {
    text-decoration: underline;
  }
`;

const ContactItem = styled.div`
  margin-right: 20px;
  font-family: "Noto Sans", sans-serif;
  display: flex;
  flex-direction: row;
  alignment: center;

`;

const TopPlaceholder = styled.div`
  width: 100%;
  height: 480px;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: ${borderRadius}px;
  background-image: url(${(props) => props.src});
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  @media (max-width: 800px) {
    height: auto;
  }
`;

const CoverSection = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  position: relative;
  border-radius: ${borderRadius}px;
  @media (max-width: 800px) {
    height: auto;
  }
`;

const WhiteCoverSection = styled.div`
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px;
  background: white;
  border-radius: ${borderRadius}px;
  box-sizing: border-box;
  @media (max-width: 800px) {
    position: relative;
  }
`;

const WhiteCoverSectionInner = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background: white;
  //height: 120px;
  @media (max-width: 800px) {
    height: auto;
  }
`;

const AvatarPlaceholder = styled.div`
  position: absolute;
  top: -120px;
  left: 20px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.src});
  border: 3px solid white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  @media (max-width: 800px) {
    top: 0px;
    left: 0px;
    right: 0px;
    margin: 0 auto;
    position: relative;
  }
`;